import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, useMediaQuery, Button, Dialog, Divider, DialogTitle, DialogContent, DialogContentText, DialogActions, Checkbox, CircularProgress} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { collection, onSnapshot, doc, getDocs,setDoc, writeBatch, deleteDoc, updateDoc, addDoc, query, where } from 'firebase/firestore';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import {db} from '../../firebaseConfig';

import {generateUniqueId} from '../../common/ItemNumberGenerator'; 

import CateringOrderInputModal from './CateringOrderInputModal';
import CateringOrderDrawerModal from './CateringOrderDrawerModal';
import { tokens } from '../../theme';
import Header from '../../components/Header';
import { IconButton, Menu, MenuItem} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';

import { logToast } from '../../common/ToastMessageLogger';

import noRecordImage from './no_cateringorders.png'; //All Lowercase with underscore

import Tile from './CateringOrderTile';

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";

const generateOrderStatusColorMap = (cateringOrders,theme) => {
  
        const orderStatusColorMap = {};
        
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;

        cateringOrders.forEach(cateringOrder => {
          if (!orderStatusColorMap[cateringOrder.orderStatus]) {
            orderStatusColorMap[cateringOrder.orderStatus] = colorFunction(cateringOrder.orderStatus);
          }
        });
      
        return orderStatusColorMap;
      };
      

    const generateOrderItemsColorMap = (cateringOrders, orderItemsMap,theme) => {
        const orderItemsColorMap = {};
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
        cateringOrders.forEach(cateringOrder => {
          (cateringOrder.orderItems || []).forEach(itemId => {
            const item = orderItemsMap[itemId];
            if (item && !orderItemsColorMap[item]) {
                orderItemsColorMap[item] = colorFunction(item);
            }
          });
        });
        return orderItemsColorMap;
      };
      
 

const stringToColorLight = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always light by adding a base value of 127
    const lightValue = ((value + 127) % 128) + 127;
    color += ('00' + lightValue.toString(16)).substr(-2);
  }
  return color;
};


const stringToColorDark = (str) => {
  return stringToColorLight(str);
};

const stringToColorDarkOLD = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always dark by restricting them to the first half of 256
    const darkValue = value % 128;
    color += ('00' + darkValue.toString(16)).substr(-2);
  }
  return color;
};


const formatFirestoreDate = timestamp => {

  if (timestamp != null && timestamp !== "")
  {
    const dateStr = new Date(timestamp.seconds * 1000).toISOString().slice(0, 10);
    const parts = dateStr.split('-');
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  } else 
  {
    return "";
  }
};

const formatFirestoreTime = timestamp => {

 if (timestamp != null && timestamp !== "")
 { 
      // Convert the seconds since Unix epoch to a Date object
    const date = new Date(timestamp.seconds * 1000);

    // Extract hours and minutes
    let hours = date.getHours();
    const minutes = date.getMinutes();

    // Determine AM or PM
    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Format hours and minutes as a time string in "hh:mm AM/PM" format
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes} ${period}`;
 } else
 {
  return "";
 }
};


const formatPhoneNumber = value => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

const formatCurrencyInteger = value => {

  if (value != null && value !=="")
  {
    return `$${Number(value).toLocaleString()}`;
  } else 
  {
    return "";
  }
};

const formatCurrency = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9.]/g, '');
      
        // If there are multiple decimal points, keep only the first one
        const parts = result.split('.');
        if (parts.length > 2) {
          result = parts[0] + '.' + parts.slice(1).join('');
        }
      
        // Allow at most two decimal places
        if (parts.length === 2 && parts[1].length > 2) {
        
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
        } else if (parts.length === 2 && parts[1].length <= 2) 
        {
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        }else
        {
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return result ? `$${result}` : '';

    } else 
    {
      return "";
    }
};



const ItemType = {
  CARD: 'card',
};

const DraggableCard = ({ cateringOrder, index, moveCard, paymentStatus, setEditingCateringOrder, setDeleteId, setConfirmOpen, cateringOrders, setShowModal, colors,theme,deleteSelectionModel,setDeleteSelectionModel,setEditingData,handleDeleteSingleItem,setDrawerOpen ,customerMap, formatCustomer,orderStatusColorMap,orderItemsMap, formatOrderItems,orderItemsColorMap }) => {
  const [, ref] = useDrag({
    type: ItemType.CARD,
    item: { id: cateringOrder.id, index, paymentStatus },
  });

    const handleDeleteSelectionChange = (id) => {
   
      setDeleteSelectionModel((prev) =>
        prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
      );
  };



  const GridActionsCellItem = ({ id }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
      event.stopPropagation();  // Stop the event propagation
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => { setAnchorEl(null); setEditingCateringOrder(null); };
    const handleDeleteAction = () => { handleDeleteSingleItem(id); };
    const handleEditAction = () => { setEditingCateringOrder(cateringOrders.find(cateringOrder => cateringOrder.id === id)); setShowModal(true); };
    const handleCloneAction = () => {
      const cateringOrderToEdit = cateringOrders.find(cateringOrder => cateringOrder.id === id);
      const clonedCateringOrder = { ...cateringOrderToEdit, id: null, name: `${cateringOrderToEdit.name} CLONED` };
      setEditingCateringOrder(clonedCateringOrder);
      setShowModal(true);
    };

    return (
      <>
        <IconButton aria-label="more" id="long-button" aria-controls={open ? 'long-menu' : undefined} aria-expanded={open ? 'true' : undefined} aria-haspopup="true" onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu id="long-menu" MenuListProps={{ 'aria-labelledby': 'long-button', sx: { backgroundColor: colors.greenAccent[700] , color: colors.grey[100] } }} anchorEl={anchorEl} open={open} onClose={handleClose}>
          <MenuItem onClick={handleCloneAction}><FileCopyIcon style={{ marginRight: 8 }} /> Clone Catering Order</MenuItem>
          <MenuItem onClick={handleDeleteAction}><DeleteIcon style={{ marginRight: 8 }} /> Delete Catering Order</MenuItem>
          <MenuItem onClick={handleEditAction}><EditIcon style={{ marginRight: 8 }} /> Edit Catering Order</MenuItem>
        </Menu>
      </>
    );
  };
  
  const handleEditAction = (id) => { setEditingCateringOrder(cateringOrders.find(cateringOrder => cateringOrder.id === id)); setShowModal(true); };

  const handleOpenDrawer = (id) => {
  
    setEditingData(cateringOrders.find(dataItem=> dataItem.id === id)); 
    setDrawerOpen(true);
    setShowModal(false);

  };

  return (
    <Card ref={ref} sx={{marginBottom: 2,backgroundColor: colors.dragAndDropDrop.tileBackgroundColor,marginLeft: '9px',marginRight: '9px',
      '&:hover': {
        backgroundColor: colors.dragAndDropDrop.tileBackgroundColorHover, 
      },
    }}
    >
      <CardContent>
  
      <Typography variant="h5" sx={{fontWeight:'800', cursor: 'pointer' }}  onClick={() => handleEditAction(cateringOrder.id)}>{formatCustomer(cateringOrder.customerId)}</Typography>
       

        <table style={{width:'100%'}}>
          <tr>
            <td> 
            <Typography variant="h7" sx={{fontWeight:'500', cursor: 'pointer', color:'#898580' }}  onClick={() => handleEditAction(cateringOrder.id)}>{cateringOrder.cateringOrderNumber}</Typography>
            </td>
            <td>  
              <span style={{float:"right"}}>
              <IconButton onClick={() => handleOpenDrawer(cateringOrder.id)}>
                  <KeyboardDoubleArrowRightIcon/>
              </IconButton>
              </span>
            </td></tr></table>
          

        <Typography variant="body2" sx={{paddingTop:'5px',paddingBottom:'5px'}}></Typography>
        
        <table style={{width:'100%'}} cellSpacing={10}>
          <tr>
            <td style={{borderBottom: '1px solid #626262'}}>
              NUMBER OF GUESTS
            </td>
            <td style={{borderBottom: '1px solid #626262'}}>
              ORDER STATUS
            </td>
          </tr>
          <tr>
            <td>
               <Typography variant='h6' sx={{fontWeight:'600'}}>
{cateringOrder.numberOfGuests}</Typography>

            </td>
            <td>
               <Typography variant='h6' sx={{fontWeight:'600'}}>

                    <Box
                                key={cateringOrder.orderStatus}
                                sx={{ 
                                    backgroundColor: orderStatusColorMap[cateringOrder.orderStatus], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    { cateringOrder.orderStatus }

                                </Box>
                    </Typography>

            </td>
          </tr>
        </table>

        <div style={{textAlign:'center'}}>
         <Typography variant='h6' sx={{fontWeight:'600'}}>

                        <Box>
                        {(cateringOrder.orderItems || []).map(id => (
                            <Box
                            key={id}
                            sx={{ 
                                backgroundColor: orderItemsColorMap[orderItemsMap[id]], 
                                borderRadius: '13px', 
                                padding: '2px 8px', 
                                display: 'inline-block', 
                                marginRight: '4px',
                                marginBottom: '4px',
                                color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                fontWeight:'600'  
                            }}
                            >
                            {orderItemsMap[id]}
                            </Box>
                        ))}
                        </Box>
                    </Typography>

        </div>

        <Box sx={{ padding: '0px', margin: '0px', height: '5px' }}>
              <div style={{ float: 'left' }}>

              <Checkbox 
              checked={deleteSelectionModel.includes(cateringOrder.id)}
              onChange={() => handleDeleteSelectionChange(cateringOrder.id)}
                                    
                                    sx={{
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        '&.Mui-checked': {
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        },
                                    }}
                                    />

              </div>
        </Box>     
        <Box sx={{ padding: '0px', margin: '0px', height: '20px' }}>

              <div style={{ float: 'right' }}>
                <GridActionsCellItem {...cateringOrder} />
              </div>
        </Box>
      </CardContent>
    </Card>
  );
};


const CateringOrders = ({ searchTerm }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [cateringOrders, setCateringOrders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingCateringOrder, setEditingCateringOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const [collectionModalOpen, setCollectionModalOpen] = useState(false);
  const [missingCollections, setMissingCollections] = useState([]);

  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteSelectionModel, setDeleteSelectionModel] = useState([]);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);

  const [selectedIdsToDelete, setSelectedIdsToDelete] = useState([]);
  const [selectedIdsNotToDelete, setSelectedIdsNotToDelete] = useState([]);

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode(); 

  const [pending, setPending] = useState([]);
const [paid, setPaid] = useState([]);
const [refunded, setRefunded] = useState([]);
const [cancelled, setCancelled] = useState([]);


  const [deleteId, setDeleteId] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [dependenciesAlertOpen, setDependenciesAlertOpen] = useState(false);

  const [deletionDependencies, setDeletionDependencies] = useState([]);

  const [processing, setProcessing] = useState(false);
  
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);

  const [selectedCateringOrder, setSelectedCateringOrder] = useState(null);

  const tilesDisplayCount = 6;

  const [visibleCount, setVisibleCount] = useState(tilesDisplayCount);

  const [showTestModeDialog, setShowTestModeDialog] = useState(false);

  const [suppressTestModeWarning, setSuppressTestModeWarning] = useState(
    localStorage.getItem('suppressTestModeSaveWarning') === 'true'
  );

  const [customerMap, setCustomerMap] = useState({});
const [orderItemsMap, setOrderItemsMap] = useState({});


  const [orderStatusColorMap, setOrderStatusColorMap] = useState({});
const [orderItemsColorMap, setOrderItemsColorMap] = useState({});


  
    useEffect(() => {
        const fetchStaticData = async () => {
            	const customerSnapshot = await getDocs(query(collection(db, "customers"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const customerData = customerSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const customerMap = customerData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.firstName+ " " +ref.lastName }), {});
	setCustomerMap(customerMap);

	const orderItemsSnapshot = await getDocs(query(collection(db, "menuItems"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const orderItemsData = orderItemsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const orderItemsMap = orderItemsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.name }), {});
	setOrderItemsMap(orderItemsMap);



            if (customerData.length === 0 || orderItemsData.length === 0) {
	let missing = [];
	if (customerData.length === 0) missing.push("customers");
	if (orderItemsData.length === 0) missing.push("menuitems");
	setMissingCollections(missing);
	setCollectionModalOpen(true);
}

        };
    
        fetchStaticData();
      }, [appUserAccountNumber, applicationMode]);
    
    

  const columns = [
	{ field: "orderName", headerName: "Order Name"},
	{ field: "customerId", headerName: "Customer"},
	{ field: "eventId", headerName: "Event"},
	{ field: "orderDate", headerName: "Order Date"},
	{ field: "eventDate", headerName: "Event Date"},
	{ field: "numberOfGuests", headerName: "Number of Guests"},
	{ field: "specialInstructions", headerName: "Special Instructions"},
	{ field: "orderStatus", headerName: "Order Status"},
	{ field: "totalCost", headerName: "Total Cost"},
	{ field: "paymentStatus", headerName: "Payment Status"},
	{ field: "paymentMethod", headerName: "Payment Method"},
	{ field: "orderItems", headerName: "Order Items"},
	{ field: "cateringOrderNumber", headerName: "cateringOrderNumber"},
	{ field: "id", headerName: "id"},
];



  useEffect(() => {

      if (!appUserAccountNumber) return; // Ensure appUserAccountNumber is available

      const cateringOrdersRef = collection(db, "cateringOrders");
      const cateringOrdersQuery = query(cateringOrdersRef, 
        where("appAccountNumber", "==", appUserAccountNumber),
        where("applicationMode", "==", applicationMode)
      );
    
      const unsubscribe = onSnapshot(cateringOrdersQuery, (snapshot) => {
        const cateringOrdersData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setCateringOrders(cateringOrdersData);
    
      /*
      const filteredCateringOrders = cateringOrdersData.filter(cateringOrder =>
        columns.some(column => cateringOrder[column.field] && cateringOrder[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
      );
      */

      const filteredCateringOrders = cateringOrdersData.filter(cateringOrder =>
        columns.some(column => {
            let value = cateringOrder[column.field];
    
            let matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());

            if (matchFound == false)
            {
              if (column.field.endsWith('Id')) {
                  const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());
    
                  try
                  {
                    value = eval(`${formatFunctionName}("${value}")`);
                    matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());
                  } catch(errr){}
              }
            }
    
            return matchFound;
    
        })
      );

      setPending(filteredCateringOrders.filter(cr => cr.paymentStatus === 'Pending'));
setPaid(filteredCateringOrders.filter(cr => cr.paymentStatus === 'Paid'));
setRefunded(filteredCateringOrders.filter(cr => cr.paymentStatus === 'Refunded'));
setCancelled(filteredCateringOrders.filter(cr => cr.paymentStatus === 'Cancelled'));


      setOrderStatusColorMap(generateOrderStatusColorMap(cateringOrdersData,theme));
setOrderItemsColorMap(generateOrderItemsColorMap(cateringOrdersData, orderItemsMap,theme));


      setLoading(false);
    }, (error) => {
      setLoading(false);
      alert("Error fetching cateringorders: ", error);
    });

    return () => unsubscribe();
  }, [appUserAccountNumber,applicationMode]);

  useEffect(() => {
   
    /*
    const filteredCateringOrders = cateringOrders.filter(cateringOrder =>
      columns.some(column => cateringOrder[column.field] && cateringOrder[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
    );
    */

    const filteredCateringOrders = cateringOrders.filter(cateringOrder =>
      columns.some(column => {
          let value = cateringOrder[column.field];
  
          if (column.field.endsWith('Id')) {
              const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());
  
              try
              {
                value = eval(`${formatFunctionName}("${value}")`);
              } catch(errr){}
          }
  
          return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
      })
    );


    setPending(filteredCateringOrders.filter(cr => cr.paymentStatus === 'Pending'));
setPaid(filteredCateringOrders.filter(cr => cr.paymentStatus === 'Paid'));
setRefunded(filteredCateringOrders.filter(cr => cr.paymentStatus === 'Refunded'));
setCancelled(filteredCateringOrders.filter(cr => cr.paymentStatus === 'Cancelled'));


}, [searchTerm]);


  //USE EFFECT TO CHANGE COLOR MAP when it changes
useEffect(() => {
  setOrderStatusColorMap(generateOrderStatusColorMap(cateringOrders,theme));
setOrderItemsColorMap(generateOrderItemsColorMap(cateringOrders, orderItemsMap,theme));

}, [theme.palette.mode, cateringOrders]);



  
 const formatCustomer = value => {

    let formattedCustomer = "";

    if (value != null && value !=="")
    {
    formattedCustomer = customerMap[value];
    }
    
    return formattedCustomer;
 };
    
                

 const formatOrderItems = value => {

    let formattedOrderItems = "";

    if (value != null)
    {
    formattedOrderItems = (value|| []).map(id => orderItemsMap[id]).join(', ') || '';
    }
    
    return formattedOrderItems;
 };
                              
                


   
  
  const moveCard = (item, toIndex, newPaymentStatus) => {
    const fromList = getList(item.paymentStatus);
    const toList = getList(newPaymentStatus);
    const [movedCard] = fromList.splice(item.index, 1);

    if (item.paymentStatus !== newPaymentStatus) {
      movedCard.paymentStatus = newPaymentStatus;
      toList.splice(toIndex, 0, movedCard);
    } else {
      fromList.splice(toIndex, 0, movedCard);
    }

    setList(item.paymentStatus, fromList);
    setList(newPaymentStatus, toList);
    updatePaymentStatus(movedCard, newPaymentStatus);
  };

  const getList = (paymentStatus) => {
    switch (paymentStatus) {
      case 'Pending':
return pending;
case 'Paid':
return paid;
case 'Refunded':
return refunded;
case 'Cancelled':
return cancelled;

      default:
        return [];
    }
  };

  const setList = (paymentStatus, list) => {
    switch (paymentStatus) {
      case 'Pending':
setPending(list);
case 'Paid':
setPaid(list);
case 'Refunded':
setRefunded(list);
case 'Cancelled':
setCancelled(list);

        break;
      default:
        break;
    }
  };

  const updatePaymentStatus = (cateringOrder, newPaymentStatus) => {
    if (!cateringOrder || !cateringOrder.id) {
      console.error("Invalid change request: ", cateringOrder);
      return;
    }

    const cateringOrderRef = doc(db, "cateringOrders", cateringOrder.id);
    updateDoc(cateringOrderRef, { paymentStatus: newPaymentStatus })
      .then(() => {
        console.log("Document successfully updated!");
      })
      .catch((error) => {
        console.error("Error updating document: ", error);
      });
  };


  const handleOpenModal = () => { setEditingCateringOrder(null); setShowModal(true); };
  
  const handleSaveCateringOrder = (cateringOrder) => {
    if (editingCateringOrder && editingCateringOrder.id) {
      setCateringOrders(prevCateringOrders => prevCateringOrders.map(c => c.id === cateringOrder.id ? cateringOrder : c));
      saveCateringOrderToDB(cateringOrder);
    } else {
      setCateringOrders(prevCateringOrders => [...prevCateringOrders, { ...cateringOrder, id: prevCateringOrders.length + 1 }]);
      addCateringOrderToDB(cateringOrder);
    }
    setShowModal(false);
    setEditingCateringOrder(null);

    if (applicationMode === 'test' && !suppressTestModeWarning) {
      setShowTestModeDialog(true);
    }
  };

  const saveCateringOrderToDB = async (cateringOrder) => {
    const cateringOrderRef = doc(db, "cateringOrders", cateringOrder.id);
    await updateDoc(cateringOrderRef, cateringOrder);
  };

  const addCateringOrderToDB = async (cateringOrder) => {
    
    const cateringOrderNumber= await generateUniqueId("cateringOrders",appUserAccountNumber);
    cateringOrder.cateringOrderNumber = cateringOrderNumber;

    cateringOrder.appAccountNumber = appUserAccountNumber;
    cateringOrder.applicationMode = applicationMode;

    const docRef = doc(db, 'cateringOrders', cateringOrderNumber);  
    await setDoc(docRef,cateringOrder);

  };

  

  const handleDeleteSelected = async () => {
    if (deleteSelectionModel.length === 0) {
      setDeleteAlertOpen(true);
      return;
    } else 
    {

      setProcessing(true);
      const idsToDelete = [];
      const idsNotToDelete = [];

      let allDeletionDependencies = [];

      //1. Identify Ids to Delete
      for (const id of deleteSelectionModel)
      {
        const dependencies = await hasDependencies(id);
    
        allDeletionDependencies = allDeletionDependencies.concat(dependencies); 

        setProcessing(false);
        
        if (dependencies.length === 0) {
          idsToDelete.push(id);
        } else 
        {
          idsNotToDelete.push(id);
        }
      }

      let uniqueDeletionDependencies = [...new Set(allDeletionDependencies)];

      setDeletionDependencies(uniqueDeletionDependencies);

      setSelectedIdsToDelete(idsToDelete);
      setSelectedIdsNotToDelete(idsNotToDelete);

      //2. Delete allowed ids

      setDeleteConfirmOpen(true);
      setProcessing(false);

    }

  };


  const handleAlertClose = () => {
    setDeleteAlertOpen(false);
  };

  
  const handleCancelDelete = () => {
      
    setDeleteConfirmOpen(false);
    setSelectedIdsToDelete([]);
    setSelectedIdsNotToDelete([]);
    setDeletionDependencies([]);
    
};


  const confirmDeleteSelected = async () => {
    try {
      const batch = writeBatch(db);
      selectedIdsToDelete.forEach(id => {
        const docRef = doc(db, "cateringOrders", id);
        batch.delete(docRef);
      });

      await batch.commit();
      logToast("The records have been delete.");

      setDeleteSelectionModel([]);
      setDeleteConfirmOpen(false);
    } catch (error) {
      console.error("Error deleting documents: ", error);
    }
  };

  const openCateringOrderDrawer = (id) => {

    const rowIndex = filteredCateringOrders.findIndex(row => row.id === id);

    const cateringOrderId = id;

    setSelectedRowIndex(rowIndex);

    const selectedCateringOrder = cateringOrders.find(p => p.id === cateringOrderId);
    if (selectedCateringOrder !== null && selectedCateringOrder != undefined)
    {  
      setSelectedCateringOrder(selectedCateringOrder);
      setDrawerOpen(true);
    }
  };

  const handleDrawerClose = () => {
      setDrawerOpen(false);
      setSelectedCateringOrder(null);
  };

  const hasDependencies = async (id) => {
    const dependencies = [];
  
    try {
      
      
                
                const billingOrderQuery = query(
                    collection(db, 'billings'),
                    where("appAccountNumber", "==", appUserAccountNumber),
                    where('orderId', '==', id)
                );
                
                const billingOrderSnapshot = await getDocs(billingOrderQuery);
                
                if (!billingOrderSnapshot.empty) {
                    dependencies.push("Billing");
                }
                
                

  
    } catch (error) {
      console.error("Error checking dependencies:", error);
      return ["error"]; // Return an array with "error" to prevent deletion in case of an issue
    }
  
    return dependencies; // Return array of collection names with dependencies
  };
  
  const handleDeleteSingleItem = async (id) => {
  
    try
    {
      
      setProcessing(true);

      const dependencies = await hasDependencies(id);
    
      setProcessing(false);
      
      if (dependencies.length === 0) {
        setDeleteId(id);
        setConfirmOpen(true);
      } else {
        setDeleteId(id);
        setDeletionDependencies(dependencies);
        setDependenciesAlertOpen(true);
      }

    } catch(error)
    {
      setProcessing(false);
    }
  };

  const handleDependenciesAlertClose = async () => {
    
      setDependenciesAlertOpen(false);
      setDeletionDependencies([]);
    
  };


  const handleConfirmClose = async () => {
    try {
      if (deleteId) await deleteDoc(doc(db, "cateringOrders", deleteId));
      setConfirmOpen(false);
      setDeleteId("");
      logToast("The record has been delete.");
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

  const handleCancelClose = () => {
    setConfirmOpen(false);
    setDeleteId("");
  };

  const handleOpenEdit = (id) => {

    setEditingCateringOrder(cateringOrders.find(cateringOrder => cateringOrder.id === id));
    setDrawerOpen(false);
    setShowModal(true); 
  }

  /*
  const filteredCateringOrders = cateringOrders.filter(cateringOrder =>
    columns.some(column => cateringOrder[column.field] && cateringOrder[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
  );
  */
  
  const filteredCateringOrders = cateringOrders.filter(cateringOrder =>
    columns.some(column => {
        let value = cateringOrder[column.field];

        if (column.field.endsWith('Id')) {
            const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());

            try
            {
              value = eval(`${formatFunctionName}("${value}")`);
            } catch(errr){}
        }

        return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
    })
  );



  const totalCateringOrders = filteredCateringOrders.length;


  return (
    <div>
      
        <Box m="20px">
          <Header title="Catering Orders By Payment Status" subtitle="List of catering orders" />
          <Box m="0px 0 0px 0" pt="10px" display="flex" >
          
            <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleDeleteSelected} disabled={loading}>
                  <RemoveCircleOutlineIcon /> &nbsp; Delete Selected
                </Button>
              &nbsp;&nbsp;&nbsp;&nbsp;

                <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleOpenModal} disabled={loading}>
                  <AddCircleOutlineIcon /> &nbsp; Add New
                </Button>
          </Box>
          {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                  <CircularProgress size={150} style={{ marginTop:'200px',color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }}  />
                </Box>
              ) : (
                <div>
                {cateringOrders.length === 0 && (
                  
                  <Box display="flex" alignItems="center" justifyContent="center" height="100%" sx={{ flexDirection: 'column' }}>
                    <img src={noRecordImage} alt="No Data" style={{ width: 250, height: 250, opacity: 0.4 }} />
                    <Typography variant="h4" sx={{ color: colors.grey[300] }}>You don't have any catering orders yet</Typography>
                    <Typography variant="h5" sx={{ color: colors.grey[400], padding: '10px' }}>Click the <span style={{ color: '#dc0000', fontWeight: 'bold' }}>"ADD NEW"</span> button above</Typography>
                  </Box>
                
                )}

                {cateringOrders.length > 0 && (
     
                <Box>
                {!isMobile ? (
     
                  <div>
                  
                  <div style={{ paddingTop:'7px',display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                   {/*   <div style={{ flex: '0 0 auto', textAlign: 'left', paddingLeft:'7px', fontSize:'11px' }}>
                          COLUMNS FILTERS
                      </div>
                    */}
                      <div style={{ margin: '0 auto', textAlign: 'center' }}>
                      You can drag and drop items from one column to the other
                      </div>
                  </div>
                  
                  <DndProvider backend={HTML5Backend}>
                    <Box display="flex" mt={1}>  {/* justifyContent="space-around" */}
                    
        <PaymentStatusColumn
              title="Pending"
              paymentStatus="Pending"
              cards={pending}
              moveCard={moveCard} 
              setEditingCateringOrder={setEditingCateringOrder} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              cateringOrders={cateringOrders}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingCateringOrder} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              customerMap={customerMap}
formatCustomer={formatCustomer}
orderStatusColorMap={orderStatusColorMap}
orderItemsMap={orderItemsMap}
formatOrderItems={formatOrderItems}
orderItemsColorMap={orderItemsColorMap}

            />
        

        <PaymentStatusColumn
              title="Paid"
              paymentStatus="Paid"
              cards={paid}
              moveCard={moveCard} 
              setEditingCateringOrder={setEditingCateringOrder} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              cateringOrders={cateringOrders}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingCateringOrder} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              customerMap={customerMap}
formatCustomer={formatCustomer}
orderStatusColorMap={orderStatusColorMap}
orderItemsMap={orderItemsMap}
formatOrderItems={formatOrderItems}
orderItemsColorMap={orderItemsColorMap}

            />
        

        <PaymentStatusColumn
              title="Refunded"
              paymentStatus="Refunded"
              cards={refunded}
              moveCard={moveCard} 
              setEditingCateringOrder={setEditingCateringOrder} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              cateringOrders={cateringOrders}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingCateringOrder} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              customerMap={customerMap}
formatCustomer={formatCustomer}
orderStatusColorMap={orderStatusColorMap}
orderItemsMap={orderItemsMap}
formatOrderItems={formatOrderItems}
orderItemsColorMap={orderItemsColorMap}

            />
        

        <PaymentStatusColumn
              title="Cancelled"
              paymentStatus="Cancelled"
              cards={cancelled}
              moveCard={moveCard} 
              setEditingCateringOrder={setEditingCateringOrder} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              cateringOrders={cateringOrders}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingCateringOrder} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              customerMap={customerMap}
formatCustomer={formatCustomer}
orderStatusColorMap={orderStatusColorMap}
orderItemsMap={orderItemsMap}
formatOrderItems={formatOrderItems}
orderItemsColorMap={orderItemsColorMap}

            />
        


                    </Box>
                  </DndProvider>
                  </div>

                ) : (    

                  <div className="tile-wrapper">

                  {filteredCateringOrders.slice(0, visibleCount).map((item, index) => ( 
                        <Tile key={index} data={item} cateringOrders={cateringOrders} setShowModal={setShowModal} setEditingData={setEditingCateringOrder} handleDeleteSingleItem={handleDeleteSingleItem} setCollectionModalOpen={setCollectionModalOpen} setMissingCollections={setMissingCollections} deleteSelectionModel={deleteSelectionModel} setDeleteSelectionModel={setDeleteSelectionModel} />
                       ))}
              
              
                  </div>

                )}
                </Box>

                )}
                

                </div>
            )}
        </Box>


        <CateringOrderDrawerModal
              drawerOpen={drawerOpen}
              handleDrawerClose={handleDrawerClose} 
              handleArrowUpClick="" 
              handleArrowDownClick=""
              selectedCateringOrder={editingCateringOrder}
              cateringOrders={cateringOrders} 
              handleOpenEdit={handleOpenEdit}
          />

      <CateringOrderInputModal isOpen={showModal} onClose={() => setShowModal(false)} onSave={handleSaveCateringOrder} cateringOrder={editingCateringOrder} />

      <Dialog open={confirmOpen} onClose={handleCancelClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this catering order?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
            No
          </Button>
          <Button onClick={handleConfirmClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteConfirmOpen} onClose={handleCancelDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm Delete"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            
          
            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length == 0) && 
              <div>Are you sure you want to delete the selected catering orders? </div>
            }

            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected catering orders with ids: &nbsp;
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>

                However, the remaining catering orders with ids: &nbsp;
                <b>{selectedIdsToDelete.join(", ")}</b><br></br> 
                will be deleted If you select <b>YES</b>. <br></br><br></br>

                Do you want to proceed deleting <b>{selectedIdsToDelete.join(", ")}</b>? 
              </div>
            }

            {(selectedIdsToDelete.length == 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected catering orders with ids: &nbsp;
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>
                Please remove these dependencies before proceeding with the deletion.
                <br></br><br></br>

                <b><u>TIP</u>:</b> You can go to each of the components listed above and type each of the ids listed one by one in the search box to find the dependent records.
              </div>
            }

          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelDelete} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
          {selectedIdsToDelete.length > 0 ? 'No' : 'OK'}
          </Button>
          {selectedIdsToDelete.length > 0 &&
          <Button onClick={confirmDeleteSelected} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
          }
        </DialogActions>
      </Dialog>
      
      <Dialog open={collectionModalOpen} aria-labelledby="collection-modal-title" aria-describedby="collection-modal-description">
        <DialogTitle id="collection-modal-title">{"Missing Records"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="collection-modal-description">
            {missingCollections.includes("customers") && <span>Please add at least one <b>customer</b> before managing catering orders. <br></br></span>}
{missingCollections.includes("menuitems") && <span>Please add at least one <b>menu item</b> before managing catering orders. <br></br></span>}

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }}  onClick={() => window.location.href = `/${missingCollections[0]}`} color="primary">
            Go to {missingCollections[0]}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteAlertOpen} onClose={handleAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            No catering orders selected for deletion.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dependenciesAlertOpen} onClose={handleDependenciesAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Delete Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
          This catering order cannot be deleted because it is linked <br></br> 
          to other dependent records in the following components:<br></br> <br></br>
          <b>{deletionDependencies.join(", ")}</b>. 
          <br></br><br></br>
          Please remove these dependencies before proceeding with the deletion.
          <br></br><br></br>

          <b><u>TIP</u>:</b> You can go to each of the components listed above and type <b>{deleteId}</b> in the search box to find the dependent records.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleDependenciesAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showTestModeDialog} onClose={() => setShowTestModeDialog(false)}>
        <DialogTitle sx={{ backgroundColor: colors.greenAccent[700] }}>
          {"Test Mode Notice"}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText>
            You are currently in <strong>Test Mode</strong>. This mode is intended for training and testing purposes only.
            <br /><br />
            If your intention is to add a live project record, please turn off test mode before proceeding.
          </DialogContentText>
          <Box mt={2}>
            <label>
              <input
                type="checkbox"
                checked={suppressTestModeWarning}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSuppressTestModeWarning(checked);
                  localStorage.setItem('suppressTestModeSaveWarning', checked);
                }}
              />{" "}
              Don't show this message again when saving in test mode
            </label>
          </Box>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button
            onClick={() => setShowTestModeDialog(false)}
            sx={{
              backgroundColor: colors.greenAccent[600],
              color: colors.primary[100],
              '&:hover': { backgroundColor: colors.greenAccent[800] }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>


    {processing && (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      zIndex={2000}
      pointerEvents="none"
    >
      <CircularProgress size={120} style={{ color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }} />
    </Box>
  )}

    </div>

  );
};

const PaymentStatusColumn = ({ title, paymentStatus, cards, moveCard, setEditingCateringOrder, setDeleteId, setConfirmOpen, cateringOrders, setShowModal, colors, theme,deleteSelectionModel,setDeleteSelectionModel,titleColor,setEditingData,handleDeleteSingleItem,setDrawerOpen ,customerMap, formatCustomer,orderStatusColorMap,orderItemsMap, formatOrderItems,orderItemsColorMap}) => {
  const [, drop] = useDrop({
    accept: ItemType.CARD,
    drop: (item) => {
      moveCard(item, cards.length, paymentStatus);
    },
  });

  return (
    <Box
    ref={drop}
    sx={{ width: '30%', minHeight: '400px', backgroundColor: colors.dragAndDropDrop.droppableAreaBackgroundColor, padding: 0, marginBottom: 5, borderTopLeftRadius: '10px', borderTopRightRadius: '10px', borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px', marginRight:2 }}
  >
    <Box 
      sx={{
        backgroundColor: titleColor === '#000000' ?  stringToColorLight(title) : titleColor,
        color: titleColor === '#000000' ? '#000000' : '#FFFFFF',
        padding: '0px',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
        marginBottom: '10px',
        marginTop: '0px',
        marginLeft: '0px',
        marginRight: '0px',
        textAlign: 'center',
        minHeight:'45px',
        paddingTop:'10px'
      }}
    >
      <Typography variant="h5" style={{fontWeight:'600',fontSize:'17px'}}>{title} ({cards.length})</Typography>
    </Box>
      {cards.map((card, index) => (
        <DraggableCard
          key={card.id}
          cateringOrder={card}
          index={index}
          moveCard={(from, to) => moveCard(from, to, paymentStatus)}
          paymentStatus={paymentStatus} 
          setEditingCateringOrder={setEditingCateringOrder} 
          setDeleteId={setDeleteId} 
          setConfirmOpen={setConfirmOpen} 
          cateringOrders={cateringOrders} 
          setShowModal={setShowModal} 
          colors={colors} 
          theme={theme} 
          deleteSelectionModel={deleteSelectionModel} 
          setDeleteSelectionModel={setDeleteSelectionModel} 
          setEditingData={setEditingData} 
          handleDeleteSingleItem={handleDeleteSingleItem}
          setDrawerOpen={setDrawerOpen}
          customerMap={customerMap}
formatCustomer={formatCustomer}
orderStatusColorMap={orderStatusColorMap}
orderItemsMap={orderItemsMap}
formatOrderItems={formatOrderItems}
orderItemsColorMap={orderItemsColorMap}

        />
      ))}
    </Box>
  );
};


export default CateringOrders;
